export const noAuthPaths = ['/admin', '/user', '/admin/', '/user/'];
